/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductUpdateDto } from '../../models/product-update-dto';

export interface ProductsControllerUpdateProduct$Params {
  productId: string;
      body: ProductUpdateDto
}

export function productsControllerUpdateProduct(http: HttpClient, rootUrl: string, params: ProductsControllerUpdateProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, productsControllerUpdateProduct.PATH, 'put');
  if (params) {
    rb.path('productId', params.productId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

productsControllerUpdateProduct.PATH = '/keus-payments/products/{productId}';
